import { FormControl } from '@angular/forms';
import { ApplianceDetailsModelSerialFormField } from '../../models/appliance-details-model-serial/appliance-details-model-serial-form-field.enum';
import { ApplianceDetailsModelSerialForm } from '../../models/appliance-details-model-serial/appliance-details-model-serial-form.interface';

export const mockApplianceDetailsModelSerialForm: ApplianceDetailsModelSerialForm =
  {
    [ApplianceDetailsModelSerialFormField.ModelNumber]: new FormControl(null),
    [ApplianceDetailsModelSerialFormField.SerialNumber]: new FormControl(null),
  };
